import { useEffect } from 'react';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { clearSupplierData, fetchSupplierById } from '../../../slices/suppliers/suppliersSlice';
import { RootState } from '../../../store';
export const useSupplierDetails = (supplierId: number) => {
  const dispatch = useAppDispatch();
  const supplier = useAppSelector((state: RootState) => state.suppliers.currentSupplierData);
  const status = useAppSelector((state: RootState) => state.suppliers.status);
  const error = useAppSelector((state: RootState) => state.suppliers.error);

  useEffect(() => {
    if (supplierId) {
      dispatch(fetchSupplierById(supplierId));
    }
    return () => {
      dispatch(clearSupplierData());
    };
  }, [supplierId, dispatch]);

  return { supplier, status, error };
};
